// extracted by mini-css-extract-plugin
export default {"categoriesTabs":"ScrollingTabs_categoriesTabs__p-k--","skeleton":"ScrollingTabs_skeleton__Z+H3Q"};